'use strict'
require('dotenv').config()

const poolData = {
  UserPoolId: 'us-east-1_X0P8OsPH0',
  ClientId: '1voenunvivkfkrd7ac3s43ni2m',
  bucketName: process.env.BUCKETNAME,
  bucketRegion: process.env.REGION,
  identityPoolId: process.env.IDENTITYPOOLID,
  accessKeyId: process.env.AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.AWS_SECRET_ACCESS_KEY
}

export default { poolData }



// WEBPACK FOOTER //
// ./src/config.js